module.exports = __webpack_public_path__ + "static/media/books.3a628436.svg";